import HeaderComponent from "../HeaderComponent";
import SectionComponent from "../SectionComponent";
import ImageComponent from "../ImageComponent";
import NavigationContainerComponent from "../NavigationContainerComponent";
import NavItemComponent from "../NavItemComponent";
import InnerSectionComponent from "../InnerSectionComponent";
import TextComponent from "../TextComponent";
import ButtonComponent from "../ButtonComponent";
import FooterComponent from "../FooterComponent";

export var defaultComponents: { [key: string]: any } = {
  header: HeaderComponent,
  section: SectionComponent,
  image: ImageComponent,
  "navigation-container": NavigationContainerComponent,
  "nav-item": NavItemComponent,
  inner_section: InnerSectionComponent,
  text: TextComponent,
  Button: ButtonComponent,
  footer: FooterComponent,
};
